module.exports = __webpack_public_path__ + "static/media/Victory.ca620353.gif";